export const transitionDuration = {
    short: '100ms',
    medium: '300ms',
    long: '500ms',
};
